import './GlassLoading.css';

const Skeleton = ({ className = '' }) => <span className={`glass-bone ${className}`} />;

const PosterSkeleton = () => (
  <div className='glass-poster-shell'>
    <Skeleton className='glass-poster' />
    <div className='glass-poster-copy'>
      <Skeleton className='glass-poster-kicker' />
      <Skeleton className='glass-poster-title' />
    </div>
  </div>
);

const GlassLoading = ({ variant = 'catalog', label = 'Loading' }) => {
  const grid = variant === 'grid' || variant === 'search';
  const rows = grid ? 1 : 3;

  return (
    <div className={`glass-loading glass-loading-${variant}`} role='status' aria-live='polite' aria-label={label}>
      <div className='glass-ambient glass-ambient-one' />
      <div className='glass-ambient glass-ambient-two' />

      {variant === 'catalog' && (
        <section className='glass-hero-skeleton'>
          <div className='glass-hero-art' />
          <div className='glass-hero-copy'>
            <Skeleton className='glass-kicker' />
            <Skeleton className='glass-title' />
            <Skeleton className='glass-line long' />
            <Skeleton className='glass-line' />
            <div className='glass-actions'><Skeleton /><Skeleton /></div>
          </div>
        </section>
      )}

      <div className='glass-loading-content'>
        {variant === 'search' && (
          <div className='glass-search-panel'>
            <div className='glass-search-heading'>
              <Skeleton className='glass-search-kicker' />
              <Skeleton className='glass-search-title' />
              <Skeleton className='glass-search-subtitle' />
              <div className='glass-search-filters'><Skeleton /><Skeleton /><Skeleton /></div>
            </div>
            <div className='glass-search-status'><i /><span>{label}</span></div>
          </div>
        )}

        {Array.from({ length: rows }, (_, row) => (
          <section className='glass-rail' key={row}>
            {variant !== 'search' && (
              <div className='glass-rail-heading'>
                <Skeleton className='glass-section-title' />
                <Skeleton className='glass-section-count' />
              </div>
            )}
            <div className={grid ? 'glass-card-grid' : 'glass-card-rail'}>
              {Array.from({ length: grid ? 10 : 7 }, (_, index) => <PosterSkeleton key={index} />)}
            </div>
          </section>
        ))}
      </div>
      <span className='visually-hidden'>{label}</span>
    </div>
  );
};

export default GlassLoading;
